<script setup lang="ts">
import { ClipboardCopy } from 'lucide-vue-next'

import useReview from '@/composables/review'

const emit = defineEmits<{
  (e: 'variableUsed', text: string): void
}>()

const { t } = useI18n()
const { availableVariables } = useReview()
</script>

<template>
  <div class="w-full">
    <ul class="divide-y divide-border rounded-md border">
      <li
        v-for="variable in availableVariables"
        :key="variable.title"
        class="flex flex-col items-center justify-between gap-2 p-3 md:flex-row"
      >
        <span class="flex-1 text-center text-sm text-foreground md:text-left">
          {{ t(`pages.review.reviewPage.variables.${variable.title}`) }}
        </span>
        <span class="flex-1 text-center text-sm text-muted-foreground md:text-left">
          {{ variable.name }}
        </span>
        <Button variant="outline" size="sm" class="shrink-0" @click="emit('variableUsed', variable.name)">
          <ClipboardCopy />
          {{ t('global.words.use') }}
        </Button>
      </li>
    </ul>

    <p class="mt-2 text-xs text-muted-foreground">
      {{ t('pages.review.reviewPage.message.variableInfo') }}
    </p>
    <p class="text-xs text-muted-foreground">
      {{ t('pages.review.reviewPage.message.variableDescription.intro') }}

      <span class="font-semibold italic">
        {{ t('pages.review.reviewPage.message.variableDescription.start') }}
        &#123;&#123; star_number &#125;&#125;
        {{ t('pages.review.reviewPage.message.variableDescription.afterVariable') }}</span
      >,
      {{ t('pages.review.reviewPage.message.variableDescription.afterPhrase') }}

      <span class="font-semibold italic">
        {{ t('pages.review.reviewPage.message.variableDescription.end') }}
      </span>
    </p>
  </div>
</template>
